<div class="container">
  <div class="row">
    <div class="col-md-8">
      <h4 class="mt-4 mb-4"><strong>Olá, {{ infoAprovador.sub }}! </strong> <br> Aqui está sua lista de Cargos <br></h4>
    </div>

    <div class="col-md-4 d-flex align-items-center justify-content-end">
      <button style="margin-inline: 6px; size: 3rem;" type="button" class="btn btn-light" (click)="gerarRelatorioCandidaturas()" pTooltip="Relatório de candidaturas">
        <i class="fas fa-file-download" style="color: rgb(91, 221, 91); font-size: 2rem;"></i>
      </button>
    </div>
  </div>
</div>

  <table class="table table-bordered">
    <thead>
      <th style="width: 90%;" class="text-center">NOME DO CARGO</th>
      <th class="text-center" >CANDIDATURAS</th>
    </thead>
    <tbody>
      <tr *ngFor="let cargo of cargos">
        <td>
          <div style="margin-left: 1rem; margin-top: 1rem;">
            <b>
          {{ cargo.nome }}
            </b>
          </div>
        </td>
        <td class="text-center">
          <button style="margin-inline: 6px;" type="button" class="btn btn-light" (click)="irParaCandidaturas(cargo.id)" pTooltip="Ir para as candidatura">
            <i class="fas solid fa-arrow-right" style="color:#F03A2B;"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
<div style="text-align: center;" *ngIf="!cargos || cargos.length === 0">
  <h5>Nenhum cargo disponível.</h5>
</div>

